var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('detail',{attrs:{"reply-data-list":_vm.replyDataList,"detail-data":_vm.detailData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }